/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getZonePricesAsync } from './DataActionExtension.g';
import { IZonePricingEntity } from './DataServiceEntities.g';

/**
 * GetZonePrices Input Action
 */
export class GetZonePricesInput implements Msdyn365.IActionInput {
    public shouldGetZonePrices: boolean;
    constructor(shouldGetZonePrices: boolean) {
        this.shouldGetZonePrices = shouldGetZonePrices;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ZonePrices`;
    public getCacheObjectType = () => 'ZonePrices';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetZonePricesData {
    zones: IZonePricingEntity[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createZonePricesInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    // @ts-expect-error
    const shouldGetZonePrices: boolean = args.config?.shouldGetZonePrices;
    return new GetZonePricesInput(shouldGetZonePrices);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetZonePricesInput, ctx: Msdyn365.IActionContext): Promise<IGetZonePricesData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    if (input.shouldGetZonePrices) {
        const response = await getZonePricesAsync({ callerContext: ctx });
        return { zones: response };
    }
    return { zones: [] };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetZonePricesData>>action,
    // TODO: Give your data action a unique id
    id: 'GetZonePrices',
    input: createZonePricesInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
